import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class VehiclesService extends AbstractService {
	static vehiclesApi = NexusService.vehiclesApi;

	static async getAll() {
		const vehicles = await this.vehiclesApi.getVehicles();
		return vehicles;
	}

	static create(data) {
		const payload = {
			vehicleCreatePayload: {},
		};

		if (Object.hasOwn(data, "Number")) {
			payload.vehicleCreatePayload.Number = data.Number;
		}

		if (Object.hasOwn(data, "LastDateUsed")) {
			payload.vehicleCreatePayload.LastDateUsed = data.LastDateUsed;
		}

		if (Object.hasOwn(data, "RecentMiles")) {
			payload.vehicleCreatePayload.RecentMiles = data.RecentMiles;
		}

		if (Object.hasOwn(data, "OrganizationId")) {
			payload.vehicleCreatePayload.OrganizationId = data.OrganizationId;
		}

		if (Object.hasOwn(data, "JurisdictionId")) {
			payload.vehicleCreatePayload.JurisdictionId = data.JurisdictionId;
		}
		return this.vehiclesApi.createVehicle(payload);
	}

	static update(id, data) {
		const payload = {
			id,
			vehicleUpdatePayload: {},
		};

		if (Object.hasOwn(data, "Number")) {
			payload.vehicleUpdatePayload.Number = data.Number;
		}

		if (Object.hasOwn(data, "LastDateUsed")) {
			payload.vehicleUpdatePayload.LastDateUsed = data.LastDateUsed;
		}

		if (Object.hasOwn(data, "RecentMiles")) {
			payload.vehicleUpdatePayload.RecentMiles = data.RecentMiles;
		}
		return this.vehiclesApi.updateVehicle(payload);
	}

	static delete(id) {
		return this.vehiclesApi.deleteVehicle({ id });
	}

	static getById(id) {
		return this.vehiclesApi.getVehicle({ id });
	}
}
